import { Router } from "@angular/router";
import { DropDownItem } from "app/components";
import { ConsultingMonitoringService, SalesManagerService } from "app/services";
import { UserSalesMessage } from "app/services/sales.service";
import { ConsultRequestSummary } from "app/services/sales/model/ConsultRequestSummary";
import { ConsultRequestSummaryData } from "app/services/sales/model/ConsultRequestSummaryData";
import { SalesManager } from "app/services/sales/model/SalesManager";
import { ConsultingMonitoringGridViewModel } from "./consulting-monitoring.viewmodel.grid";


export class ConsultingMonitoringViewModel {
    private currentQueryId = null;
    private summary: ConsultRequestSummary;
    
    public gridDatas: ConsultRequestSummaryData[] = null;
    public gridViewModel: ConsultingMonitoringGridViewModel;
    public salesManagerDropDownItems: DropDownItem<SalesManager>[] = [];
    public selectedSalesManager: SalesManager = null;
    public selectedQueryDes: string = "";

    public queryItems: DropDownItem<string>[] = [
        new DropDownItem<string>("조회 쿼리를 선택하세요", null),
        new DropDownItem<string>("부킹 요청 대기", "close-no-history"),
        // new DropDownItem<string>("[1-1-2] 물류비 견적 마감 100시간 이내 & 진행중, 운송완료, 도착완료 이력있음", "close-history"),
        new DropDownItem<string>("견적 참여 대기", "not-confirmed-no-history"),
        // new DropDownItem<string>("[1-1-4] 물류비 견적 요청대기 상태 24시간 이상 100시간 이하 & 견적처리 불가능 사유 없음 & 진행중, 운송완료, 도착완료 이력있음", "not-confirmed-history"),
        new DropDownItem<string>("제공 견적 최초 유효 만료 전", "waiting-booking-history"),
        new DropDownItem<string>("제공 견적 마지막 유효 만료 전", "closed-booking-history"),
        new DropDownItem<string>("첫 진행완료 화주조회", "recent-complete-no-history"),
        new DropDownItem<string>("재이용 진행완료 화주조회", "recent-complete-history"),
        new DropDownItem<string>("진행완료 일주일 경과 화주", "recent-complete-review"),
        new DropDownItem<string>("견적 미이용 신규회원", "no-history")
    ];

    private queryDesc: Map<string, string> = new Map([
        ["close-no-history", "물류비 견적 완료 물류비 견적 마감 24시간 ~ 100시간 이내"],
        ["not-confirmed-no-history", "물류비 견적 미완료 물류비 견적 참여대기 상태 24시간 이상 100시간 이하 & 견적처리 불가능 사유 없음"],
        ["waiting-booking-history", "부킹 대기중 물류비 견적건의 참여 포워더 운임 validity 만료 100시간 이내(복수의 포워더 운임이 있는경우 가장 빠른 만료일 기준)"],
        ["closed-booking-history", "부킹 대기중 물류비 견적건의 참여 포워더 운임 validity 만료 100시간 이내(모든 포워더 운임 기준)"],
        ["recent-complete-no-history", "운송완료(첫진행) 최근 168시간 이내 운송완료 이력 있음 & 운송완료 이력 1건"],
        ["recent-complete-history", "운송완료(재이용) 최근 168시간 이내 운송완료 이력 있음 & 운송완료 이력 2건 이상"],
        ["recent-complete-review", "사용후기 운송완료 168시간 이상 & 운송완료 504시간 이내 이력있음"],
        ["no-history", "가입 후 12시간 이후 & 물류비견적 이력없음"]
    ]);

    set showMessageBtnCallback (callback: (data: ConsultRequestSummaryData) => void) {
        this.gridViewModel.showMessageBtnCallback = callback;
    }

    constructor(private consultingMonitoringService: ConsultingMonitoringService, private salesManagerService: SalesManagerService,  private router: Router) {
        this.gridViewModel = new ConsultingMonitoringGridViewModel(router);        
        this.initDropDownSalesManager();
    }


    private initDropDownSalesManager() {
        this.salesManagerDropDownItems= [
            new DropDownItem<SalesManager>("전체", null),
        ];

        this.salesManagerService.getSalesManagers(salesManagers => {
            if (salesManagers) {
                for (const salesManager of salesManagers) {
                    const s = new SalesManager(salesManager);
                    this.salesManagerDropDownItems.push(new DropDownItem<SalesManager>(s.fullName, s));
                }
            }
        });
    }

    
    
    private getConsultRequestSummaryCallback = (summary: ConsultRequestSummary) => {
        this.summary = summary;
        this.gridDatas = this.filterByManager(this.summary.summaryDatas, this.selectedSalesManager);
        this.gridViewModel.updateColumnDefinitions(this.summary.hasSummaries, this.summary.hasRequest, this.summary.hasComplete, this.summary.hasLingoStatus);
        this.gridViewModel.hideLoading();
    }


    public selectQuery(selectedItem: DropDownItem<string>) {
        if (this.currentQueryId !== selectedItem.value) {
            this.currentQueryId = selectedItem.value;

            if (this.currentQueryId) {
                this.selectedQueryDes = this.queryDesc.get(this.currentQueryId);
                this.gridViewModel.showLoading();
                this.consultingMonitoringService.getConsultRequestSummaryByUsers(this.currentQueryId, this.getConsultRequestSummaryCallback);
            } else {
                this.selectedQueryDes = "";
            }

            
        }
    }

    public selectManager(selectedItem: DropDownItem<SalesManager>) {
        this.selectedSalesManager = selectedItem.value;
        this.gridDatas = this.filterByManager(this.summary.summaryDatas, this.selectedSalesManager);
    }


    private filterByManager(summaryDatas: ConsultRequestSummaryData[], salesManager : SalesManager): ConsultRequestSummaryData[] {
        let filteredDatas: ConsultRequestSummaryData[] = [];
        if (!salesManager) {
            filteredDatas = summaryDatas;
        } else {
            for (const d of this.summary.summaryDatas) {
                if (d.salesManagerUserId && d.salesManagerUserId === salesManager.userId) {
                    filteredDatas.push(d);
                }
            }
        }

        return filteredDatas;
    }


    public closeMessageModalCallback() {
        const viewModel: ConsultingMonitoringViewModel = this;

        return (userId: number, messages: UserSalesMessage[]) => {
            for (const u of viewModel.gridDatas) {
                if (u.userId === userId) {
                    if (messages && messages.length > 0) {
                        u.hasMessage = true;
                    } else {
                        u.hasMessage = false;
                    }
                }
            }
            viewModel.gridViewModel.gridApi.rowDataChanged(viewModel.gridDatas);
        };
    }

}


// WEBPACK FOOTER //
// ./src/app/containers/sales/consulting-monitoring.viewmodel.ts